import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {flexFieldsSegmentsTableAdapter, flexFieldsSettingsTableAdapter} from './flex-fields-slice';
import {FLEX_FIELDS_SLICE} from './flex-fields-slice-constants';

export const selectFlexFieldsSliceState = (state: TAppState) => state[FLEX_FIELDS_SLICE];

export const flexFieldsSettingsTableAdapterSelectors = flexFieldsSettingsTableAdapter.getSelectors(
    (state: TAppState) => selectFlexFieldsSliceState(state).flexFieldsSettingsTable,
);

export const flexFieldsSegmentsTableAdapterSelectors = flexFieldsSegmentsTableAdapter.getSelectors(
    (state: TAppState) => selectFlexFieldsSliceState(state).flexFieldsSegmentsTable,
);

export const selectFlexFieldRecord = createSelector(
    selectFlexFieldsSliceState,
    ({flexFieldsRecord}) => flexFieldsRecord,
);
